import moment from "moment";
import Status from "@/domainObjects/Status";
import Disposition from "@/domainObjects/hold/Disposition";
import Defect from "@/domainObjects/hold/Defect";
import Plant from "@/domainObjects/Plant";
import HoldQiDetails from "@/domainObjects/hold/HoldQiDetails";
import HoldActionItems from "@/domainObjects/hold/HoldActionItems";

export default class HoldTicket {
    //attachments: any;
    attachmentCount: number;
    closedBy: string;
    closedDate: Date | number | string;
    color: string;
    comments: string;
    cparNumber: string;
    daysOpen: any;
    defect: Defect;
    disposition: Disposition;
    dispositionBy: string;
    dispositionComments: string;
    dispositionDate: string | Date;
    holdActionItems: HoldActionItems[];
    holdQiDetails: HoldQiDetails[];
    holdTicketId: number;
    labor: number;
    lineItem: string;
    materialDesc: string;
    materialNumber: string;
    onHoldBy: string;
    onHoldDate: string | Date;
    optionNumber: string;
    parentId: number;
    plant: Plant;
    productionOrderNum: string;
    productionOrderQty: string;
    producedByShift: string;
    productionDate: string | Date;
    purchaseOrderNum: string;
    quantityOnHold: number;
    responsibleForAction: string;
    returnAuthNum: string;
    reverificationRequired: string;
    salesOrderNumber: string;
    skidNumsOnHold: string;
    status: Status;
    skidsOnHold: string;
    workCenter: string;
    // not sure if i need to keep these because these need to be used in ticket creation
    defectId: number;
    statusId: number;
    plantCode: string;
    dispositionId: number;
    piecesGood: number;
    piecesAwaiting: number;
    piecesRemaining: number;
    piecesReturned: number;
    piecesScrap: number;
    totalReworkHours: number;
    actionTrackingAvailable: boolean;
    loaded: boolean;
    disableEditMaterial: boolean;
    disableEditAll: boolean;

    constructor() {
        this.holdTicketId = 0;
        this.attachmentCount = 0;
        this.parentId = 0;
        this.daysOpen = 0;
        this.dispositionId = 0;
        this.defectId = 0;
        this.defect = new Defect();
        this.plant = new Plant();
        this.plantCode = "";
        this.status = new Status();
        this.statusId = 9;
        this.productionOrderNum = "";
        this.productionOrderQty = "";
        this.salesOrderNumber = "";
        this.returnAuthNum = "";
        this.purchaseOrderNum = "";
        this.materialDesc = "";
        this.materialNumber = "";
        this.lineItem = "";
        this.optionNumber = "";
        this.color = "";
        this.workCenter = "";
        this.producedByShift = "";
        this.quantityOnHold = 0;
        this.skidsOnHold = "";
        this.skidNumsOnHold = "";
        this.onHoldBy = "";
        this.closedBy = "";
        this.comments = "";
        this.disposition = new Disposition();
        this.dispositionComments = "";
        this.reverificationRequired = "";
        this.responsibleForAction = "";
        this.dispositionBy = "";
        this.cparNumber = "N/A";
        this.holdQiDetails = [new HoldQiDetails()];
        this.dispositionDate = "";
        this.closedDate = "";
        this.onHoldDate = "";
        this.productionDate = "";
        this.labor = 0;
        this.holdActionItems = [new HoldActionItems()];
        this.piecesGood = 0;
        this.piecesAwaiting = 0;
        this.piecesRemaining = 0;
        this.piecesReturned = 0;
        this.piecesScrap = 0;
        this.totalReworkHours = 0;
        this.loaded = false;
        this.actionTrackingAvailable = false;
        this.disableEditMaterial = true;
        this.disableEditAll = false;
    }

    initFromObject(holdTicket) {
        this.holdTicketId = holdTicket.holdTicketId;
        this.attachmentCount = holdTicket.attachmentCount;
        this.parentId = holdTicket.parentId;
        this.dispositionId = holdTicket.dispositionId;
        this.defectId = holdTicket.defectId;
        this.defect = holdTicket.defect;
        this.plant = holdTicket.plant;
        this.plantCode = holdTicket.plantCode;
        this.status = holdTicket.status;
        this.statusId = holdTicket.statusId;
        this.productionOrderNum = holdTicket.productionOrderNum;
        this.productionOrderQty = holdTicket.productionOrderQty;
        this.salesOrderNumber = holdTicket.salesOrderNumber;
        this.returnAuthNum = holdTicket.returnAuthNum;
        this.purchaseOrderNum = holdTicket.purchaseOrderNum;
        this.materialDesc = holdTicket.materialDesc;
        this.materialNumber = holdTicket.materialNumber;
        this.lineItem = holdTicket.lineItem;
        this.optionNumber = holdTicket.optionNumber;
        this.color = holdTicket.color;
        this.workCenter = holdTicket.workCenter;
        this.producedByShift = holdTicket.producedByShift;
        this.quantityOnHold = holdTicket.quantityOnHold;
        this.skidsOnHold = holdTicket.skidsOnHold;
        this.skidNumsOnHold = holdTicket.skidNumsOnHold;
        this.onHoldBy = holdTicket.onHoldBy;
        this.closedBy = holdTicket.closedBy;
        this.comments = holdTicket.comments;
        this.disposition = holdTicket.disposition;
        this.dispositionComments = holdTicket.dispositionComments;
        this.reverificationRequired = holdTicket.reverificationRequired;
        this.responsibleForAction = holdTicket.responsibleForAction;
        this.dispositionBy = holdTicket.dispositionBy;
        this.cparNumber = holdTicket.cparNumber;
        this.holdQiDetails = holdTicket.holdQiDetails;
        this.holdActionItems = holdTicket.holdActionItems;
        this.dispositionDate = holdTicket.dispositionDate;
        this.closedDate = holdTicket.closedDate;
        this.onHoldDate = holdTicket.onHoldDate;
        this.productionDate = holdTicket.productionDate;
        this.labor = holdTicket.labor;
        this.piecesGood = holdTicket.piecesGood;
        this.piecesAwaiting = holdTicket.piecesAwaiting;
        this.piecesRemaining = holdTicket.piecesRemaining;
        this.piecesReturned = holdTicket.piecesReturned;
        this.piecesScrap = holdTicket.piecesScrap;
        this.totalReworkHours = holdTicket.totalReworkHours;
        this.loaded = holdTicket.loaded;
        this.actionTrackingAvailable = holdTicket.actionTrackingAvailable;
        this.disableEditMaterial = true;
        this.disableEditAll = false;
        this.daysOpen = this.calculateDaysOpen(holdTicket.onHoldDate);
    }


    calculateDaysOpen(openDate): number {
        if (openDate) {
            let end;
            if (this.closedDate) {
                end = new Date(this.closedDate).toISOString().split('T');
            } else {
                end = new Date().toISOString().split('T');
            }
            let start = new Date(openDate).toISOString().split('T');
            let momentEnd = moment(end[0], 'YYYY-MM-DD');
            let momentStart = moment(start[0], 'YYYY-MM-DD');
            return Math.abs(momentStart.diff(momentEnd, "days"));
        } else {
            return -1;
        }
    }

    getQtyBalanceByLocation(location): number {
        let totalActionItemQty = 0;
        let totalQiHold = 0;

        //First - get the full quantity from the initial creation
        for (let j = 0; j < this.holdQiDetails.length; j++) {
            //WipQiHoldDetail detail = (WipQiHoldDetail)qiHoldDetails.get(j);
            if (this.holdQiDetails[j].location != null && this.holdQiDetails[j].location.toLowerCase() === location.toLowerCase()) {
                totalQiHold = this.holdQiDetails[j].quantity;
            }
        }

        //Next, we need to add all action line items for that location
        for (let i = 0; i < this.holdActionItems.length; i++) {
            //WipActionItem item = (WipActionItem)wipActionItems.get(i);
            if (this.holdActionItems[i].location != null && this.holdActionItems[i].location.toLowerCase() === location.toLowerCase()) {
                totalActionItemQty += this.holdActionItems[i].quantity;
            }
        }
        return totalQiHold - totalActionItemQty;
    }

    toJSON() {
        return {
            closedBy: this.closedBy,
            color: this.color,
            comments: this.comments,
            cparNumber: this.cparNumber,
            daysOpen: this.daysOpen, // delete once the data is retrieved from server instead of client
            defect: this.defect,
            disposition: this.disposition,
            dispositionBy: this.dispositionBy,
            dispositionComments: this.dispositionComments,
            holdActionItems: this.holdActionItems,
            holdQiDetails: this.holdQiDetails,
            holdTicketId: this.holdTicketId,
            labor: this.labor,
            lineItem: this.lineItem,
            materialDesc: this.materialDesc,
            materialNumber: this.materialNumber,
            onHoldBy: this.onHoldBy,
            optionNumber: this.optionNumber,
            parentId: this.parentId,
            plant: this.plant,
            productionOrderNum: this.productionOrderNum,
            productionOrderQty: this.productionOrderQty,
            producedByShift: this.producedByShift,
            purchaseOrderNum: this.purchaseOrderNum,
            quantityOnHold: this.quantityOnHold,
            responsibleForAction: this.responsibleForAction,
            returnAuthNum: this.returnAuthNum,
            reverificationRequired: this.reverificationRequired,
            salesOrderNumber: this.salesOrderNumber,
            skidNumsOnHold: this.skidNumsOnHold,
            status: this.status,
            skidsOnHold: this.skidsOnHold,
            workCenter: this.workCenter,
            // not sure if i need to keep these because these need to be used in ticket creation
            defectId: this.defectId,
            statusId: this.statusId,
            plantCode: this.plantCode,
            dispositionId: this.dispositionId,
            dispositionDate: this.dispositionDate,
            closedDate: this.closedDate,
            onHoldDate: this.onHoldDate,
            productionDate: this.productionDate
        }
    }

}


